const ABSOLUTE = /^(?:[a-z][a-z\d+.-]*:|\/\/)/i

/**
 * Полный адрес картинки из `photos`, `photo_items` или `cover_url`. Сервер
 * отдаёт путь `/media/<key>` от своего корня — без домена и без `/api/v1`.
 * Картинка лежит на домене API, а не приложения, поэтому путь достраиваем
 * до того же домена, куда ходят запросы. Если API на том же домене
 * (`/api/v1` через прокси), путь остаётся как есть.
 */
export function mediaUrl(path: string, apiBaseUrl: string): string {
  if (path === '' || ABSOLUTE.test(path)) return path
  const origin = ABSOLUTE.test(apiBaseUrl) ? new URL(apiBaseUrl).origin : ''
  return `${origin}/${path.replace(/^\/+/, '')}`
}
